export type TImageTypes = 'all' | 'photo' | 'illustration' | 'vector' | 'video'

export type TVideoTypes = 'all' | 'film' | 'animation'

export enum Orientation {
  all = 'all',
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export enum Category {
  animals = 'animals',
  backgrounds = 'backgrounds',
  buildings = 'buildings',
  business = 'business',
  computer = 'computer',
  education = 'education',
  fashion = 'fashion',
  feelings = 'feelings',
  food = 'food',
  health = 'health',
  industry = 'industry',
  music = 'music',
  nature = 'nature',
  people = 'people',
  places = 'places',
  religion = 'religion',
  science = 'science',
  sports = 'sports',
  transportation = 'transportation',
  travel = 'travel',
}

export enum Color {
  transparent = 'transparent',
  black = 'black',
  blue = 'blue',
  brown = 'brown',
  gray = 'gray',
  grayscale = 'grayscale',
  green = 'green',
  lilac = 'lilac',
  orange = 'orange',
  pink = 'pink',
  red = 'red',
  turquoise = 'turquoise',
  white = 'white',
  yellow = 'yellow',
}

export enum OrderBy {
  popular = 'popular',
  latest = 'latest',
}
